import React, { useState } from 'react';
import UI from "components/UI";
import { Link , useLocation, useHistory } from 'react-router-dom';
import moment from 'moment';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIInputMask from 'components/input/UIInputMask';

import UISelect from 'components/selectbox/UISelect';
import CommonUtil from 'utils/CommonUtil';
import ValidationUtil from "common/validation/util/ValidationUtil";
import DateUtil from "utils/DateUtil";
import StringUtil from "utils/StringUtil";
import codeDataStore from "common/codedata/store/CodeDataStore";
import TbComFile from "domain/main/com/file/TbComFile";
import DaumPostcode from "react-daum-postcode";
import ModalPopup from 'components/modal/';
import useToggleState from 'components/hooks/useToggleState';
import UIUtils from "utils/UIUtils";

function ContentsContainer(props: any) {
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
  	const history = useHistory();

	const [bizLicFileValue] = useState(new TbComFile());
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);

	const [corpSizeCd,setCorpSizeCd] = useState('');
	const [corpNm,setCorpNm] = useState('');
	const [induCd,setInduCd] = useState('');
	const [bizNo,setBizNo] = useState('');
	const [corpRegNo,setCorpRegNo] = useState('');
	const [ceoNm,setCeoNm] = useState('');
	const [evalDivCd,setEvalDivCd] = useState('');
	const [evalCd,setEvalCd] = useState('');
	const [grpNm,setGrpNm] = useState('');
	const [estaDate,setEstaDate] = useState(new Date());
	const [estaFormCd,setEstaFormCd] = useState('');
	const [corpZipCd,setCorpZipCd] = useState('');
	const [corpAddr1,setCorpAddr1] = useState('');
	const [corpAddr2,setCorpAddr2] = useState('');
	const [homepageUrl,setHomepageUrl] = useState('');
	const [regNm,setRegNm] = useState('관리자');
	const [prvtMngr,setPrvtMngr] = useState('');
	// 폼체크 여부 
	const [formCheck,setFormCheck] = useState(false);  

	let today:string = DateUtil.currentDateFormat("YYYY-MM-DD HH:mm:ss");
	const modalpostcode = useToggleState({});

	//우편번호 찾기 콜백
	const handleComplete = (data) => {
		setCorpZipCd(data.zonecode);
		setCorpAddr1(data.address);
		modalpostcode.close();
	};

	//우편번호 찾기 스타일
	const postCodeStyle = {
		display: "block",
	};  

	//파일업로드 
	const [uploadId, setUploadId] = React.useState("");
    
	//파일업로드 
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

	//파일업로드 완료
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
	    console.log(JSON.stringify(arrayNew));
	
		let fileInfos : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
		}[] = [];

		let fileInfo : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
		};

		//파일등록 정보
		arrayNew?.forEach((item, index) => {
			if(item.status =="complete"){
				fileInfo = {
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:item.extension,
				}

				fileInfos.push(fileInfo);
			}
		})
		setFileInfoList(fileInfos);
	
    }

	const onFileUpload = () => {
		if(uploadId){
			window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}

	//기업 등록전 파일업로드 파라미터 체크
	async function corpFormCheck(){

		if(ValidationUtil.checkAll()) {
			// 검증이 유효하지 않은 경우
			return;
		}

		if(ceoNm == "" || induCd == "" || corpSizeCd == "" || corpZipCd == "" || corpAddr1 == "" || corpAddr2 == ""){
			await UIUtils.alert(<>필수 입력이 완료되지 않았습니다.<br/> 다시 확인해 주세요.</>);
			return;
		}
		
		if(await UIUtils.confirm('저장하시겠습니까?')){
			setFormCheck(true);  //폼 체크 여부 
			onFileUpload();
		}
	};

	//기업 등록
	async function corpCreate(sendParam){

		const response:any = await CommonUtil.execute({
			url:'adm_4212',
			data: sendParam
		})
		.then((response: any) => {
			if(response.ERR_CD =="9999"){
					UIUtils.alert(response.ERR_MSG).then();
					return;
			}else{
				UIUtils.alert('저장되었습니다.').then( () => {
					let vBIZ_NO = response.BIZ_NO;
					let dataToSend = {
						vBIZ_NO
					}
	
					history.push({
						pathname: './adm4210',    //저장후 상세페이지로 이동
						state: { data: dataToSend }
					});
				});
				
			}
		}).catch(err => {
			CommonUtil.showAxiosError(err);
			return;
		});

		
	}
	
	// 파일 업로드 성공여부 체크
	React.useEffect(() => {
		if(fileInfoList && formCheck) {
			let param = {
				BIZ_NO:bizNo,
				CORP_REG_NO:corpRegNo,
				CORP_NM:corpNm,
				CEO_NM:ceoNm,
				CORP_SIZE_CD:corpSizeCd,
				INDU_CD:induCd,
				ESTA_DATE:DateUtil.toDateFormat(estaDate, "YYYY-MM-DD"),
				ESTA_FORM_CD:estaFormCd,
				GRP_NM:grpNm,
				EVAL_DIV_CD:evalDivCd,
				EVAL_CD:evalCd,
				CORP_ZIP_CD:corpZipCd,
				CORP_ADDR_1:corpAddr1,
				CORP_ADDR_2:corpAddr2,
				HOMEPAGE_URL:homepageUrl,
				FILE_INFO_LIST:fileInfoList,
				PRVT_MNGR:prvtMngr
			}
			
			//console.log("param : "+JSON.stringify(param));
			//환수정보 저장 
			corpCreate(param);
		}
	}, [fileInfoList])

	const goList = () =>{
		history.push({
			pathname: './adm4200',    //저장후 상세페이지로 이동
			state: { data: receivedData }
		});
	}

	// init 
	React.useEffect(() => {

		//필요한 공통코드 로딩.
		codeDataStore.read("/common/useYn", "[EVC]", "[EVDC]", "[SCS]", "[INC]", "[EFC]");
		
    },[])

	return (
		<PageContainer session={false}>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">사용자관리</Link></li>
					<li><Link to="#">기업관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">기업등록</h1>
					<h2 className="tx tx-hd3">기본정보</h2>
					<div className="fo fo-col2" >
						<div className="inner">
							<div className="fo-item req"> 
								<p className="fo-key">기업규모</p>
								<div className="fo-value">
									<div className="sl sl-md">
										<UISelect
											firstName={"sel"}
											codeData={codeDataStore.get("[SCS]")}
											value={corpSizeCd}
											valueChanged={(value) => setCorpSizeCd(String(value))}	
											rules={["required"]}
										/>
									</div>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">업종</p>
								<div className="fo-value">
									<div className="sl sl-md">											
										<UISelect
											firstName={"sel"}
											codeData={codeDataStore.get("[INC]")}
											value={induCd}
											valueChanged={(value) => setInduCd(String(value))}
											rules={["required"]}
										/>
									</div>
								</div>						
							</div>
							<div className="fo-item req">
								<p className="fo-key">법인등록번호</p>
								<div className="fo-value">
									<UIInputMask
										mask={"999999-9999999"}
										className={'tf tf-md w100p'} 
										value={corpRegNo}
										valueChanged={(value) => setCorpRegNo(value)}
										rules={["required"]}
										/>
								</div>						
							</div>
							<div className="fo-item req"> 
								<p className="fo-key">사업자등록번호</p>
								<div className="fo-value">
									<UIInputMask
										mask={"999-99-99999"}
										className={'tf tf-md w100p'} 
										value={bizNo}
										valueChanged={(value) => setBizNo(value)}
										rules={["required"]}
										/>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">기업명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={'기업명'} valueChanged={(value) => setCorpNm(value)} rules={["required"]}/>
								</div>						
							</div>
							<div className="fo-item req">
								<p className="fo-key">대표자명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={ceoNm} placeholder={'대표자명'} valueChanged={(value) => setCeoNm(value)} rules={["required"]}/>
								</div>						
							</div>
							<div className="fo-item"> 
								<p className="fo-key">평가구분</p>
								<div className="fo-value">
									<div className="sl sl-md">
										<UISelect
											firstName={"sel"}
											codeData={codeDataStore.get("[EVDC]")}
											value={evalDivCd}
											valueChanged={(value) => setEvalDivCd(value)}
										/>
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">평가</p>
								<div className="fo-value">
									<div className="sl sl-md">
										<UISelect
											firstName={"sel"}
											codeData={codeDataStore.get("[EVC]")}
											value={evalCd}
											valueChanged={(value) => setEvalCd(value)}
										/>
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">집단</p>
								<div className="fo-value">
									<UIInput type="text" className={'tf tf-md w100p'}  value={grpNm} valueChanged={(value) => setGrpNm(value)} placeholder={'집단'}/> 
								</div>						
							</div>
							<div className="fo-item"> 
								<p className="fo-key">설립일자</p>
								<div className="fo-value">
									<UIDatePicker value={estaDate} valueChanged={(value) => setEstaDate(value)} showToday={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">설립형태</p>
								<div className="fo-value">
									<div className="sl sl-md">
										<UISelect
											firstName={"sel"}
											codeData={codeDataStore.get("[EFC]")}
											value={estaFormCd}
											valueChanged={(value) => setEstaFormCd(String(value))}
										/>
									</div>
								</div>						
							</div>
							<div className="fo-item req">
								<p className="fo-key">주소</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8">
										<UIInput className={'hz-item tf tf-md w120'} value={corpZipCd} valueChanged={(data: any) => setCorpZipCd(data)} placeholder={'우편번호'} rules={["required"]}/>
										<UIInput className={'hz-item tf tf-md hz-fg w262'} value={corpAddr1} valueChanged={(value) => setCorpAddr1(value)} placeholder={'주소'} rules={["required"]}/>
										<Button color="gray-o" size="md" onClick={modalpostcode.open}>우편번호 찾기</Button>
									</div>
								</div>					
							</div>
							{/*<div className="fo-item">
								<p className="fo-key">홈페이지</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={homepageUrl} valueChanged={(value) => setHomepageUrl(value)} placeholder={'홈페이지'}/>
								</div>						
							</div>*/}
							<div className="fo-item">
								<p className="fo-key">민간자율 기획사업 담당자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={prvtMngr} valueChanged={(value) => setPrvtMngr(value)} placeholder={'민간자율 기획사업 담당자'}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">상세주소</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={corpAddr2}	valueChanged={(value) => setCorpAddr2(value)} placeholder={'상세주소'} />
								</div>						
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">가상계좌확인서</p>
								<div className="fo-value">
									<div className="inner w100p">
											<UI.FileUpload
												onCreationComplete={onCreationComplete}
												onUploadComplete={onUploadComplete}
												attrs={{
													MaxTotalFileCount: "3",
													ExtensionAllowOrLimit: "1",
													ExtensionArr: "pptx,ppt,pdf,doc,docx,xls,xlsx,hwp,hwpx,gif,jpg,jpeg,png",
												}}
											/>
									</div>
								</div>	
							</div>	
							<div className="fo-item">
								<p className="fo-key">등록자</p>
								<div className="fo-value">
									<UIInput type="text" className={'tf tf-md w100p'} value={regNm} valueChanged={(value) => setRegNm(value)}  placeholder={'등록자'} readOnly={true} />
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">등록일시</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={''} readOnly={true}/>
								</div>		
							</div>
						</div>
					</div>	
					<h2 className="tx tx-hd3">사업자등록증 이력</h2>
					<div className="tb-view-file">
						<UI.FileDownloadSimpleMode value={bizLicFileValue} viewMode={"bizLic"} rowNumber={true}/>
					</div>
					<div className="hz-root hz-right hz-gap5">
						<Button color="pri-o" size="sm" onClick={corpFormCheck}>저장</Button>
						<Button color='gray-o' size="sm" onClick={goList}>목록</Button>
					</div>
				</main>

			</div>
			{/* modal - 우편번호 검색 */}
			<ModalPopup
				open={modalpostcode.isShowing}
				title="우편번호 검색"
				size="sm"
				onClose={modalpostcode.close} >
				<div className="modal-con">
					<DaumPostcode onComplete={handleComplete} style={postCodeStyle} />
				</div>
			</ModalPopup>	
		</PageContainer>
	);
}
export default ContentsContainer;

